import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';
import { brandByExternalId, brandByExternalIdVariables } from './types/brandByExternalId';

@Injectable({
  providedIn: 'root',
})
export class BrandDetailsGQL extends Query<brandByExternalId, brandByExternalIdVariables> {
  document = gql`
  query brandByExternalId($externalId: String) {
    brandByExternalId(externalId: $externalId) {
      id
      name
      properties {
        id
        name
        code
        latitude
        longitude
        hotelCategory
        street
        state
        city
        postalCode
        slug
        description
        propertyImages {
          id
          accessCode
          imagePath
        }
        metaDescription
        metaTitle
        phoneAreacode
        phoneNumber
        webUrl
      }
      images {
        id
        accessCode
        imageName
        imagePath
        subCaption
        caption
        sortOrder
        hyperlink
        hyperlinkButtonLabel
        brandImage
        rate
        rateLabel
        status
      }
      featuredProperties {
        id
        code
        name
        hotelCategory
        street
        city
        state
        slug
        description
        teaserImage {
          id
          accessCode
          amazonS3Url
        }
        webUrl
      }
    }
  }`;
}